import React, {useEffect} from 'react';
import { MdCircle } from 'react-icons/md';
import { useAppStore } from '../../../../../GlobalStore/GlobalStore';
import ModelProvider from "./ModelProvider/ModelProvider.tsx";

interface ModelInfo {
    name: string;
    isPremium: boolean;
    config?: {
        reasoningEffort: string;
    };
}

interface ModelOption {
    provider: string;
    models: ModelInfo[];
}

export const modelOptions: ModelOption[] = [
    {
        provider: 'Anthropic',
        models: [
            { name: 'Claude-Fable', isPremium: true },
            { name: 'Claude-Opus', isPremium: true, config: { reasoningEffort: 'Automatic' } },
            { name: 'Claude-Sonnet', isPremium: true, config: { reasoningEffort: 'Automatic' } },
            { name: 'Claude-Haiku', isPremium: true }
        ]
    },
    {
        provider: 'OpenAI',
        models: [
            { name: 'GPT', isPremium: true },
            { name: 'GPT-Mini', isPremium: false }
        ]
    },
    {
        provider: 'Google',
        models: [
            { name: 'Gemini-Pro', isPremium: true },
            { name: 'Gemini-Flash', isPremium: false }
        ]
    },
    {
        provider: 'xAI',
        models: [
            { name: 'Grok', isPremium: true }
        ]
    },
    // {
    //     provider: 'Other',
    //     models: [
    //         { name: 'GLM', isPremium: false }
    //     ]
    // }
];


interface ModelsDropdownProps {
    handleModelSelect: (model: string) => void;
    setIsOpen: (isOpen: boolean) => void;
    isOpen: boolean;
}
const ModelsDropdown: React.FC<ModelsDropdownProps> = ({ handleModelSelect, setIsOpen, isOpen }) => {
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);

    useEffect(() => {
        if (dynamicStateObj.visiblePopup !== null) setIsOpen(false);
    }, [dynamicStateObj.visiblePopup]);

    const automaticOption = (
        <div
            className="w-full flex justify-between items-center px-4 py-2.5 hover:bg-neutral-200 dark:hover:bg-neutral-800 cursor-pointer"
            onClick={() => handleModelSelect("Automatic")}
        >
            <div className="flex-1" />
            <div className="flex text-base font-semibold tracking-wide">
                <span className="dark:bg-gradient-to-r dark:from-cyan-300 dark:via-cyan-400 dark:to-blue-400 bg-gradient-to-r from-cyan-400 via-cyan-600 to-blue-600 bg-clip-text text-transparent">
                    Automatic
                </span>
            </div>
            <div className="flex-1 flex justify-end">
                {settingsObj.model === "Automatic" && <MdCircle size={11} className="text-cyan-600 dark:text-cyan-500" />}
            </div>
        </div>
    );

    return (
        <div className={`w-56 md:w-64 border border-neutral-800 mr-auto mt-1 justify-center bg-neutral-100 dark:bg-neutral-900 rounded-lg shadow-lg max-h-72 overflow-y-auto absolute top-full left-1/2 transform -translate-x-1/2 transition-all duration-200 ease-out origin-top ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-98 pointer-events-none'}`}>
            {automaticOption}
            {modelOptions.map((option: ModelOption) => (
                <ModelProvider
                    key={option.provider}
                    option={option}
                    handleModelSelect={handleModelSelect}
                    setIsOpen={setIsOpen}
                />
            ))}
        </div>
    );
};

export default ModelsDropdown;
